import { render, staticRenderFns } from "./claimedit.vue?vue&type=template&id=49362989&scoped=true&"
import script from "./claimedit.vue?vue&type=script&lang=js&"
export * from "./claimedit.vue?vue&type=script&lang=js&"
import style0 from "./claimedit.vue?vue&type=style&index=0&id=49362989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49362989",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49362989')) {
      api.createRecord('49362989', component.options)
    } else {
      api.reload('49362989', component.options)
    }
    module.hot.accept("./claimedit.vue?vue&type=template&id=49362989&scoped=true&", function () {
      api.rerender('49362989', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/claimedit.vue"
export default component.exports